import {useMutation, useQueryClient} from "@tanstack/react-query";
import {updateAccountPagoMovil} from "../../services/wallet/accounts";

const useEditAccPagoMovil = () => {
  const queryClient = useQueryClient();
  const {isError, isPending, isSuccess, error, mutate} = useMutation({
    mutationKey: ["updateMobileAccount"],
    mutationFn: updateAccountPagoMovil,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userMobileAccount"]});
    },
  });

  return {
    isErrorUpdate: isError,
    isPendingUpdate: isPending,
    isSuccessUpdate: isSuccess,
    errorUpdate: error,
    update: mutate,
  };
};

export default useEditAccPagoMovil;
